import script from "./DonationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationBanner.vue?vue&type=script&setup=true&lang=ts"

import "./DonationBanner.vue?vue&type=style&index=0&id=7a5657b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5657b0"]])

export default __exports__